import api from './axios'
import {authHeader} from '../helpers'

export const authService = {
    login,
    refreshToken,
    logout,
    handleResponse,
    getApiVersion,
    currentUser,
    parseJwt
}


function login(username, password) {
    return api.post('/Authorize/authenticate', {username, password})
        .then(handleResponse)
        .then(token => {
            if (token?.token) {
                localStorage.setItem('token', JSON.stringify(token))
            }
            return token
        })
}

function refreshToken() {
    return api.get('/Authorize/refreshToken', {
        headers: authHeader()
    })
        .then(handleResponse)
        .then(token => {
            if (token?.token) {
                localStorage.setItem('token', JSON.stringify(token))
            }
            return token
        })
}

function currentUser(username) {

    return api.get(`/Utilisateur/username`, {
        headers: authHeader()
    })
        .then(handleResponse)
        .then(data => {
            return data
        })
}

function getApiVersion() {
    return api.get('/Authorize/version', {
        headers: authHeader()
    })
        .then(handleResponse)
}

async function logout() {
    const requestOptions = {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        credentials: 'include', // <- c'est ça qui inclut les cookies
    };

    await fetch(`${process.env.VUE_APP_API_PROXY_URL}/auth/logout`, requestOptions)

    await localStorage.removeItem('token')
    await localStorage.removeItem('user')
    await localStorage.removeItem('bdlttoken')

}

function parseJwt(token) {
    if (!token) return null
    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
}

function handleResponse(response) {
    return response.data
}
